import css from '../../ComplaintForm/ComplaintForm.module.css'
import { InspectWBR } from './pages/inspect'
import {
  datePage,
  fileUploadPage,
  narrativePage,
  otherChoicePage,
  permissionToDisclosePage,
  reviewPage,
  subjectPage,
  witnessCorroborationPage,
  witnessPage,
  yesNoPage
} from '../../../pages'
import { whistleblowerRetaliationAction } from '../../../choices'
import {
  complainantDetailsPage,
  employmentPage,
  protectedCommunicationPage,
  protectedDisclosurePage,
  retaliationReasonsPage,
  warningPage
} from './pages'
import {
  EmploymentWarning,
  ProtectedCommunicationWarning,
  ProtectedDisclosureWarning,
  RetaliationReasonsWarning
} from './warnings'
import { approxDateMessage } from '../../../validators/dateYup'

export const formSchema = saveComplaint => {
  const pageAfterSubject = 'witness_corroboration_page'
  const subjectDescription =
    'Please provide contact information that will help us identify the person responsible for the retaliatory action(s).'

  // Define the whistleblower retaliation specific pages
  const wbrPages = [
    otherChoicePage({
      pageId: 'retaliation_actions_page',
      fieldName: 'retaliation_action',
      fieldNameOther: 'retaliation_action_other',
      fieldType: 'checkbox',
      label:
        'Have you experienced any of the following for reporting fraud, waste, or abuse?',
      labelOther: 'Please enter your other experience',
      className: css.choices,
      labelClassName: css.largeLabel,
      choices: whistleblowerRetaliationAction()
    }),
    retaliationReasonsPage(),
    protectedDisclosurePage(),
    warningPage({
      pageId: 'protected_disclosure_warning_page',
      fieldName: 'protected_disclosure_warning',
      label: 'PD Warn',
      warning: ProtectedDisclosureWarning
    }),
    protectedCommunicationPage(),
    warningPage({
      pageId: 'protected_communication_warning_page',
      fieldName: 'protected_communication_warning',
      label: 'PC Warn',
      warning: ProtectedCommunicationWarning
    }),
    {
      ...datePage({
        pageId: 'protected_disclosure_date_page',
        fieldName: 'disclosure_date',
        required: true,
        label: 'When did you first report this fraud, waste, or abuse?',
        hint: approxDateMessage,
        labelClassName: css.largeDateLabel
      }),
      action: {
        type: 'goto',
        pageId: 'employment_page'
      }
    },
    warningPage({
      pageId: 'retaliation_reason_warning_page',
      fieldName: 'retaliation_reasons_warning',
      label: 'RR Warn',
      warning: RetaliationReasonsWarning
    }),
    employmentPage(),
    warningPage({
      pageId: 'employment_warning_page',
      fieldName: 'employer_warning',
      label: 'Emp Warn',
      warning: EmploymentWarning
    }),
    datePage({
      pageId: 'action_begin_date_page',
      fieldName: 'date_of_activity',
      required: true,
      label: 'When did the retaliatory action(s) begin?',
      hint:
        "If you can't provide an exact date which the retaliation action(s) began, please select an approximate begin date",
      labelClassName: css.largeDateLabel
    }),
    yesNoPage({
      pageId: 'action_happening_page',
      fieldName: 'still_happening',
      label: 'Is the retaliatory action(s) still happening now?',
      className: css.choices,
      labelClassName: css.largeLabel,
      gotoPageYes: 'subject_page_0',
      gotoPageNo: 'action_end_date_page'
    }),
    datePage({
      pageId: 'action_end_date_page',
      fieldName: 'activity_end_date',
      required: true,
      label: 'When did the retaliatory action(s) end?',
      hint:
        "If you can't provide an exact date which the retaliation action(s) ended, please select an approximate end date",
      labelClassName: css.largeDateLabel
    }),
    subjectPage({ pageAfterSubject, description: subjectDescription }),
    subjectPage({
      index: 1,
      pageAfterSubject,
      description: subjectDescription
    }),
    subjectPage({
      index: 2,
      pageAfterSubject,
      description: subjectDescription
    }),
    subjectPage({
      index: 3,
      pageAfterSubject,
      description: subjectDescription
    }),
    subjectPage({
      index: 4,
      pageAfterSubject,
      description: subjectDescription
    }),
    subjectPage({
      index: 5,
      pageAfterSubject,
      description: subjectDescription
    }),
    subjectPage({
      index: 6,
      pageAfterSubject,
      description: subjectDescription
    }),
    subjectPage({
      index: 7,
      pageAfterSubject,
      description: subjectDescription
    }),
    subjectPage({
      index: 8,
      pageAfterSubject,
      description: subjectDescription
    }),
    subjectPage({
      index: 9,
      pageAfterSubject,
      description: subjectDescription
    }),
    witnessCorroborationPage({
      gotoPageYes: 'witness_page_0',
      gotoPageNo: 'narrative_page'
    }),
    witnessPage({ maxIndex: 4 }),
    witnessPage({ index: 1, maxIndex: 4 }),
    witnessPage({ index: 2, maxIndex: 4 }),
    witnessPage({ index: 3, maxIndex: 4 }),
    witnessPage({ index: 4, maxIndex: 4 }),
    narrativePage({
      label: 'Please describe the retaliation in your own words'
    }),
    fileUploadPage(),
    complainantDetailsPage(),
    {
      ...permissionToDisclosePage({
        pageId: 'non_anon_permission_to_disclose_page',
        choices: 'non_anon',
        fieldName: 'non_anon_perm_to_disclose'
      }),
      action: {
        type: 'goto',
        pageId: 'review_page'
      }
    },
    permissionToDisclosePage(),
    reviewPage(InspectWBR)
  ]

  return {
    title: 'Whistleblower Retaliation Complaint Form',
    onSubmit: formValues => saveComplaint(formValues),
    pages: wbrPages
  }
}
